import { render, staticRenderFns } from "./GoodList.vue?vue&type=template&id=dc2b3aa4&scoped=true"
import script from "./GoodList.vue?vue&type=script&lang=js"
export * from "./GoodList.vue?vue&type=script&lang=js"
import style0 from "./GoodList.vue?vue&type=style&index=0&id=dc2b3aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2b3aa4",
  null
  
)

export default component.exports